import { Component } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { AuthSelectors } from '../../../../core/auth/selectors/auth.selectors';
import { NavbarActions } from '../../../../core/nav-bar/actions/nav-bar.actions';
import { NavbarSelectors } from '../../../../core/nav-bar/selectors/nav-bar.selectors';
import { BaseAppState } from '../../../../core/store/reducers';
import { environment } from '../../../../../environments/environment';
import { OptionalApplicationFeature } from 'ngx-esprio-shared';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
})
export class NavBarComponent {
  public isLoggedIn$ = this.store.pipe(select(AuthSelectors.isLoggedIn));
  public isMenuOpen$ = this.store.select(NavbarSelectors.getIsHamburgerMenuOpen);
  public languagePickerDisabled = environment.disabledAppFeatures.includes(
    OptionalApplicationFeature.LanguagePicker
  );

  constructor(private store: Store<BaseAppState>) {}

  public handleToggleHamburgerMenu() {
    this.store.dispatch(NavbarActions.toggleHamburgerMenu());
  }
}
